import React from 'react'
import classNames from 'classnames'

const EnterpriseErrorComponent = ({
  title = '',
  content = '',
  isButton = false,
  containerClassName = '',
  titleClassName = '',
  iconClassName = '',
  contentClassName = '',
  buttonClassName = '',
  IconComponent,
  buttonTitle = '',
  buttonClickHandler = () => {}
}) => {

  return (
    <div>
      <div className={classNames('flex flex-col items-center', containerClassName)}>
        {IconComponent && <IconComponent className={classNames(
          'text-[#666666] w-[72px] h-[72px]',
          iconClassName
        )} />}
        <div
          className={classNames(
            'mt-[12px] font-noto-sans text-[28px] font-bold leading-[39px] text-[#666]',
            titleClassName
          )}
        >
          {title}
        </div>
        <div className={classNames(
          "mt-[12px] font-noto-sans text-md font-normal leading-[24px] text-[#191919]",
          contentClassName
        )}>
          {content}
        </div>
        {isButton && (
          <div className={classNames(
            "flex items-center justify-center mt-[24px] py-[14px] px-[24px] text-base text-[#191919] font-bold leading-20 rounded-sm border-[1px] border-solid border-[#989898] cursor-pointer",
            buttonClassName
          )}
          onClick={()=>{buttonClickHandler()}}
          >
            {buttonTitle}
          </div>
        )}
      </div>
    </div>
  )
}

export default EnterpriseErrorComponent
